import gql from 'graphql-tag'

export const ACCOUNT_QUERY = gql`
query me($userId: ID!) {
  me {
    id
    firstName
    lastName
    email
    userProfile {
      phone
    }
  }
  secondaryCoachingPeriods(coachId: $userId) {
    id
    startDate
    endDate
  }
}
`
